
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Campaign } from "@/types/campaigns";

export const useDuplicateCampaign = (userId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (campaign: Campaign): Promise<Campaign> => {
      if (!userId) throw new Error("User ID is required");

      console.log('Duplicating campaign:', campaign);
      
      const duplicateData = {
        user_id: userId,
        name: `${campaign.name} (Cópia)`,
        type: campaign.type,
        product: campaign.product,
        value: campaign.value,
        start_date: campaign.start_date,
        end_date: campaign.end_date,
        description: campaign.description,
        status: 'draft' as const,
      };

      const { data: newCampaign, error } = await supabase
        .from('campaigns')
        .insert(duplicateData)
        .select()
        .single();

      if (error) throw error;
      return {
        ...newCampaign,
        product: newCampaign.product as "cashback" | "referral",
        status: newCampaign.status as "draft" | "scheduled" | "active" | "completed" | "cancelled"
      } as Campaign;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns', userId] });
      toast.success("Campanha duplicada com sucesso");
    },
    onError: (error) => {
      console.error('Error duplicating campaign:', error);
      toast.error("Erro ao duplicar campanha");
    },
  });
};
